import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { SelectApiSlComponent } from '../../neovis-graph/select-api-sl/select-api-sl.component';

@Component({
  selector: 'details-node-sl',
  templateUrl: './details-node-sl.component.html',
  styleUrls: ['./details-node-sl.component.scss'],
})
export class DetailsNodeSlComponent implements OnInit {
  modal_type: string = 'node';
  image: any;
  node: any;
  keys: any;
  constructor(
    public dialog: MatDialogRef<DetailsNodeSlComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitization: DomSanitizer,
    public dialogOpen: MatDialog
  ) {}

  ngOnInit() {
    console.log(this.data.node);
    this.node = this.data.node;
    this.image = this.sanitization.bypassSecurityTrustStyle(
      `url(${this.node.image})`
    );
    console.log(this.node.raw.labels[0]);

    this.node.titulo = this.node.raw.labels[0];
    this.keys = this.assignCategories(this.node.raw.properties);
    this.node.subtitulo = 'XXXX';
    console.log(this.keys);
  }

  assignCategories(properties: any): any[] {
    const nameKeys = [
      'first_name',
      'last_name',
      'username',
      'name',
      'alias',
      'person',
      'fullname',
    ];
    const companyKeys = ['company_name'];
    return Object.entries(properties).map(([key, value]) => {
      let category = '';
      if (nameKeys.includes(key)) {
        category = 'nombre';
      } else if (companyKeys.includes(key)) {
        category = 'empresa';
      }
      if (category != '') {
        return {
          key,
          value,
          category,
        };
      } else {
        return {
          key,
          value,
        };
      }
    });
  }

  async socialLinkSearch(
    category: string = undefined,
    value: string = undefined
  ) {
    const dialogRef = this.dialogOpen.open(SelectApiSlComponent, {
      data: { node: this.node, nodeId: this.node.id, category, value },
      panelClass: 'custom-dialog-container',
    });
    dialogRef.afterClosed().subscribe((res) => {
      console.log('res desde el neovis-grph.compoenet');
    });
  }

  close() {
    this.dialog.close();
  }
}
